import { css, StyleSheet } from 'aphrodite'
import { PropTypes } from 'prop-types'
import React, { useState } from 'react'
import IconStar from '../Icon/IconStar'
import { RATE_COLOR } from '../../lib/colors'

const UIRating = ({
  nbStar = 5,
  dynamicStyle,
  dynamicStyleStar,
  onClick,
  disabled,
}) => {
  const [starHovered, setStarHovered] = useState(-1)

  return (
    <div className={css(styles.div, dynamicStyle)}>
      {Array.from(Array(nbStar)).map((value, index) => {
        return (
          <IconStar
            key={index}
            onClick={() => {
              if (!disabled) {
                onClick(index)
                setStarHovered(index)
              }
            }}
            isActive={!disabled ? starHovered > index - 1 : true}
            color={RATE_COLOR}
            dynamicStyle={dynamicStyleStar ? dynamicStyleStar : styles.star}
          />
        )
      })}
    </div>
  )
}

const styles = StyleSheet.create({
  div: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },
  star: {
    cursor: 'pointer',
  },
})

UIRating.propTypes = {
  nbStar: PropTypes.number,
  dynamicStyle: PropTypes.node,
  dynamicStyleStar: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default UIRating
